<style scoped>
#peiHistoryRoot >>> .search-bar {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  position: absolute;
  top: -58px;
  right: 12px;
  width: 400px;
}

#peiHistoryRoot >>> .search-container {
  margin-top: 80px;
}

@media only screen and (max-width: 768px) {
  .custom-title-box {
    position: relative;
  }
  #peiHistoryRoot >>> .search-container {
    margin-bottom: -43px;
  }
  #peiHistoryRoot >>> .search-bar {
    position: relative;
    right: unset;
    width: 100%;
  }
}
</style>

<template>
  <div id="peiHistoryRoot" class="pl-4 pr-4">
    <div class="row search-container" v-if="!readOnly">
      <div class="col">
        <div
          class="search-bar p-3 d-flex flex-row justify-content-end float-right"
        >
          <v-select
            v-if="showYearsFilter"
            :value="selectedAcademicYear"
            :options="academicYearsList"
            class="peiHistoryDropdown w-100 mr-3"
            :clearable="false"
            :searchable="true"
            :reduce="(year) => year.year"
            label="description"
            @input="setSelected"
          />
          <ActionButton
            data-target="#add-previous-evaluations-modal"
            data-toggle="modal"
            data-backdrop="static"
            variant="success"
            class="px-4"
            @click="onSearch()"
          >
            Buscar
          </ActionButton>
        </div>
      </div>
    </div>
    <custom-title-divider title="Historial del Estudiante" v-if="!readOnly" />

    <div v-if="peiHistoryData.length > 0" class="search-result mt-3">
      <PeiHistoryResultRow
        v-for="row in peiHistoryData"
        :key="`${row.peiIdFormatted}`"
        ref="pei"
        :value="row"
        :has-saee10-report="row.hasSaee10Report"
        :read-only="readOnly"
        @goPeiTabs="goPeiTabs(row)"
        @goDocuments="goDocuments(row)"
        @goToControversy="goToControversy(row)"
        @getInd7PeiReport="getInd7PeiReport(row)"
        @getInd13PeiReport="getInd13PeiReport(row)"
        @getReferralPeiReport="getReferralPeiReport(row)"
        @getAtServiceReport="getAtServiceReport(row)"
        @getReportsPEIPS="getReportsPEIPS(row)"
        @getReportsPEIPSFromStorage="getReportsPEIPSFromStorage(row)"
        @getSAEE10Report="buildSAEE10Report(row.peiIdFormatted)"
        @getTransportationRequestReport="getTransportationRequestReport(row)"
        @getTransportationRequestReportAEE="
          getTransportationRequestReportAEE(row)
        "
        @deletePeiReport="deletePeiReport(row)"
        @getPeiReportBlank="peiReportInBlank(row)"
        @downloadSheetRefferal="downloadSheetRefferal(row)"
        @goToComments="goToComments"
        @generateReferral="generateReferral"
        @closeShowErrorPanel="closeShowErrorPanel(row.peiIdFormatted)"
        @downloadEquipmentAT="downloadReportEquipmentAT(row)"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.perPage"
        :data="pagination"
        :page-size="pagination.perPage"
        @pagination-go-page="onPageChanged"
      />
    </div>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css';
import store from '@/store/index';
import DropDown from '@/components/common/menu/DropDown';
import userRoles from '@/utils/constants/userRoles';
import PeiStatus from '@/utils/constants/pei/peiStatus';
import generalService from '@/services/pei/general';
import reportService from '@/services/report';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { CustomTitleDivider, ActionButton } from '@/components/common';
import Pagination from 'pagination';
import PeiHistoryResultRow from './components/PeiHistoryResultRow';
import documentsService from '@/services/documents';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import commentTypes from '@/utils/constants/comment/commentTypes';
import peiStatuses from '@/utils/constants/pei/peiStatus';

export default {
  name: 'PeiHistory',
  mixins: [alertMixin],
  components: {
    DropDown,
    CustomTitleDivider,
    ActionButton,
    Pagination,
    PeiHistoryResultRow,
  },
  props: {
    showActionsColumn: { type: Boolean, default: true },
    showYearsFilter: { type: Boolean, default: true },
    studentSieId: { type: String, default: () => '' },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      reportUpdateRoles: [
        userRoles.admin,
        userRoles.adminIl,
        userRoles.adminSaee,
        userRoles.tecnico,
      ],
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      pei: {}, // PEI flags
      peiId: null,
      peiHistoryData: [],
      academicYearsList: [],
      selectedAcademicYear: '0',
      items: [],
    };
  },
  computed: {
    StudentId() {
      const studentSie = parseInt(this.studentSieId);
      return studentSie > 0
        ? studentSie
        : store.getters['$_student/StudentSie'];
    },
  },
  watch: {
    StudentId(newValue) {
      if (newValue) this.getStudentPEI();
    },
  },
  methods: {
    async buildSAEE10Report(peiId) {
      try {
        const { data } = await this.$ApiGet(`/api/report/saee10/${peiId}`);
        await generalService.documentDownloadReport(
          data.content,
          data.filename
        );
      } catch (error) {
        this.ShowToast(
          '',
          'Ocurrio un problema al descargar el reporte, vuelve a intentarlo.',
          'error'
        );
      }
    },
    async peiReportInBlank(row) {
      await this.deletePeiReport(row); // Actualizar PEI.
      const downloadReportInBlank = true;
      await this.getReportsPEIPS(row, downloadReportInBlank); // Descargar PEI.
    },
    getReportsChildren(props) {
      const self = this;
      return [
        {
          show: this.verifyPeiPSReportAccess(props.formattedRow),
          icon: 'fas fa-file-download text-green',
          title: 'Reporte del PEI o PS',
          onClick: () => self.getReportsPEIPS(props.row.peiIdFormatted),
        },
        {
          show: props.row.peiReferralFlag,
          icon: 'fas fa-file-download text-green',
          title: 'Reporte de Referidos del PEI o PS',
          onClick: () => self.getReferralPeiReport(props.row.peiIdFormatted),
        },
        {
          show: props.row.peiAtServiceFlag,
          icon: 'fas fa-file-download text-green',
          title: 'Reporte de Guía de AT',
          onClick: () => self.getAtServiceReport(props.row.peiIdFormatted),
        },
        {
          show:
            self.verifyRoleAccess(self.reportUpdateRoles) &&
            self.verifyPeiUpdateReportAccess(props.formattedRow),
          icon: 'fas fa-redo text-orange',
          title: 'Actualizar Reporte del PEI o PS',
          onClick: () => self.getReportsPEIPS(props.row.peiIdFormatted),
        },
        {
          show: props.row.transportationReportFlag,
          icon: 'fas fa-file-download text-green',
          title: 'Reporte Solicitud de Transportación',
          onClick: () =>
            self.getTransportationRequestReport(props.row.peiIdFormatted),
        },
      ];
    },
    setPeiInformation: function(action) {
      let peiId = action.peiIdFormatted.replace('-', '');
      this.$store.dispatch('setSelectedPei', peiId);
      this.$store.dispatch(
        'setATServiceAmmendment',
        action.atServiceAmmendment
      );
      store.commit(
        'setSelectedPeiRevisionNo',
        parseInt(action.generalRevisionNo)
      );
      store.dispatch('setSelectedPeiStatus', action.peiStatusId);
      store.dispatch(
        'setSelectedPeiStatusDescription',
        action.peiStatusDescription
      );
      this.peiId = peiId;
    },
    goPeiTabs: function(row) {
      this.setPeiInformation(row);
      this.validatePei(row);
      store.commit('setCompensatoryServices', []);
    },
    generateReferral() {
      let self = this;
      self
        .$ApiPost(
          '/api/pei/generateReferralFromPei?studentSieId=' + this.StudentId
        )
        .then(() => {
          this.ShowToast(
            '',
            'El referido ha sido generado exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast(
              'Error',
              'Ha ocurrido un error inesperado.',
              'error'
            );
          }
        });
    },
    async validatePei(row) {
      // Validar si es un PEI/PS con enmienda y no tiene secciones seleccionadas (guardadas en db)
      // Se redirige a la pantalla de enmienda llamada "Parte a evaluar en la Enmienda"
      if (
        row.peiStatusId == peiStatuses.Borrador &&
        row.generalRevisionNo > 0
      ) {
        const {
          data: amendmentSelectedSections,
        } = await generalService.getSAmendmentByPeiId(row.peiIdFormatted);
        if (
          amendmentSelectedSections &&
          amendmentSelectedSections?.length == 0
        ) {
          this.$store.dispatch(
            'setSelectedPeiAcademicYearId',
            row.academicYearId
          );
          this.goToPeiAmendment();
          return;
        }
      }

      await this.getPeiFlags();
      //Enmienda PEI REGULAR
      if (
        this.pei.peiStatusCode == '1' &&
        this.pei.unilateralFlag == '0' &&
        this.pei.configLocationRejectFlag == '0'
      ) {
        if (this.pei.hasAmendment == false && this.pei.generalRevisionNo > 0)
          this.goToPeiAmendment();
        else this.goToPeiDetails();
      } else if (
        this.pei.peiStatusCode == '1' &&
        this.pei.unilateralFlag == '1' &&
        this.pei.configLocationRejectFlag == '0'
      ) {
        //Enmienda PS
        if (this.pei.hasLocation == false) this.goToPeiDefinition();
        else if (
          this.pei.hasAmendment == false &&
          this.pei.generalRevisionNo > 0
        )
          this.goToPeiAmendment();
        else this.goToPeiDetails();
      } else if (
        this.pei.unilateralFlag == '1' &&
        this.pei.peiStatusCode == '1' &&
        (this.pei.locationRegionId == null ||
          this.pei.configLocationDistrictId == null ||
          this.pei.peiLocationId == null)
      ) {
        //si es un PS y locationRiegionId o configLocationDistrictId o peiLocationid están vacíos
        this.goToPeiDefinition();
      } else this.goToPeiDetails();
    },
    goToPeiAmendment() {
      let tabValidations = {
        validation: false,
      };
      store.dispatch('setPeiValidationTriggered', tabValidations);
      this.$router.push({
        path: '/pei/amendment/',
      });
    },
    goToPeiDefinition() {
      let tabValidations = {
        validation: false,
      };
      store.dispatch('setPeiValidationTriggered', tabValidations);
      const peiId = store.getters.SelectedPei;
      this.$router.push({
        path: `/pei/definition/${peiId}`,
      });
    },
    goToPeiDetails() {
      let tabValidations = {
        validation: false,
      };
      store.commit('setPeiValidationTriggered', tabValidations);
      this.$router.push({
        path: '/pei/detail/',
      });
    },
    async getPeiFlags() {
      return this.$ApiGet(`/api/pei/${this.peiId}/flags`)
        .then((res) => {
          this.pei = res.data;
          store.commit(
            'setSelectedPeiConfigUnilateralFlag',
            this.pei.unilateralFlag
          );
          store.commit(
            'setSelectedPeiConfigExtendedSchoolYearFlag',
            this.pei.extendedSchoolYearFlag
          );
          store.commit(
            'setSelectedPeiConfigOtherServTechAssistEquipFlag',
            this.pei.otherServTechAssistEquipFlag
          );
          store.commit(
            'setSelectedPeiAcademicYearId',
            this.pei.configAcademicYearId
          );
          store.commit(
            'setSelectedTransitionServicesFlag',
            this.pei.configTransitionServicesFlag
          );
        })
        .catch((err) => {
          this.response = err;
        });
    },
    goToControversy(item) {
      this.setPeiInformation(item);
      this.$router.push({
        path: `/pei/controversy/`,
      });
    },
    goDocuments(item) {
      this.setPeiInformation(item);
      this.$router.push({
        path: `/pei/documents/`,
      });
    },
    goControversia() {
      this.$router.push({
        path: ``,
      });
    },
    getReportsPEIPS(item, inBlank = false) {
      let peiId = item.peiIdFormatted.replace('-', '');
      let self = this;

      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/report/pei/' + peiId + `?inBlank=${inBlank}`)
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
            const message =
              err?.response?.data?.message ??
              'Ha ocurrido un error inesperado.';
            self.ShowToast('', message, 'error');
          });
      });
      return promise;
    },
    getReportsPEIPSFromStorage(item) {
      if (item.signedPeiAttachmentId) {
        return documentsService.downloadFromServer(item.signedPeiAttachmentId);
      } else {
        this.getReportsPEIPS(item);
      }
    },
    deletePeiReport(item) {
      let peiId = item.peiIdFormatted.replace('-', '');
      let self = this;

      self
        .$ApiPost('/api/report/deletepeireport/' + peiId)
        .then(() => {
          this.ShowToast(
            '',
            'El documento de PDF de PEI fue actualizado exitósamente.',
            'success'
          );
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast(
              'Error',
              'Ha ocurrido un error inesperado.',
              'error'
            );
          }
        });
    },
    async getReferralPeiReport(item) {
      let peiId = item.peiIdFormatted.replace('-', '');
      let self = this;

      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/report/pei/referralreport/' + peiId)
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async getInd13PeiReport(item) {
      let peiId = item.peiIdFormatted.replace('-', '');
      let self = this;

      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/report/pei/ind13report/' + peiId)
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async getInd7PeiReport(item) {
      let peiId = item.peiIdFormatted.replace('-', '');
      let self = this;

      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/report/pei/ind7report/' + peiId)
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },

    async getAtServiceReport(peiId) {
      let self = this;

      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/report/atservice/' + peiId.peiIdFormatted)
          .then((res) => {
            self.report = res.data;
            if (self.report.content == null) {
              this.ShowToast('', 'El reporte no pudo ser generado', 'error');
              return;
            }
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async getTransportationRequestReport(item) {
      const peiId = item.peiIdFormatted.replace('-', '');
      const analysisServiceId = 0;

      await reportService.downloadTransportation(peiId, analysisServiceId);
    },
    async getTransportationRequestReportAEE(item) {
      const peiId = item.peiIdFormatted.replace('-', '');
      const analysisServiceId = 0;

      await reportService.downloadTransportationAEE(peiId, analysisServiceId);
    },
    async downloadReportEquipmentAT(row) {
      const params = {
        peiId: row.peiIdFormatted,
        studentSieId: row.studentSieId,
      };

      await reportService.downloadEquipmentUsageGuaranteeDocument(params);
    },
    getReportsPEIPSReferido(peiID) {
      return peiID;
    },
    UpdateReportsPEIPS(peiID) {
      return peiID;
    },
    verifyRoleAccess(roles) {
      let roleAccess = false;
      const userRole = this.userRole;
      if (roles === undefined) {
        roleAccess = true; // show
      }

      if (roles) {
        roleAccess = roles.find((x) => x == userRole) ? true : false;
      }
      return roleAccess;
    },
    verifyPeiUpdateReportAccess(peiObj) {
      const status = [
        PeiStatus.Completado,
        PeiStatus.Firmado,
        PeiStatus.SignedWithControversy,
      ];
      return status.findIndex((x) => x == peiObj.peiStatusId) >= 0;
    },
    verifyPeiStatusForAtService(peiObj, peiAtServiceFlag) {
      return peiObj.peiStatusId == PeiStatus.Firmado && peiAtServiceFlag;
    },
    verifyTransportationRequestPermission(peiObj, transportationReportFlag) {
      return (
        (peiObj.peiStatusId == PeiStatus.Firmado ||
          peiObj.peiStatusId == PeiStatus.PartialSignedPendingFunds ||
          peiObj.peiStatusId == PeiStatus.SignedWithControversy) &&
        transportationReportFlag
      );
    },
    verifyPeiPSReportAccess(peiObj) {
      return (
        peiObj.peiStatusId != PeiStatus.Cancelado &&
        peiObj.peiStatusId != PeiStatus.Incompleto
      );
    },
    verifyControversyQuestionnaireAccess(peiObj) {
      return peiObj.peiStatusId == PeiStatus.SignedWithControversy;
    },
    getStudentPEI() {
      if (this.StudentId != undefined && this.StudentId != null) {
        this.$ApiGet(
          '/api/pei/gethistory?studentSieId=' +
            this.StudentId +
            '&year=' +
            this.selectedAcademicYear +
            '&pageNumber=' +
            this.pagination.currentPage +
            '&pageSize=' +
            this.pagination.perPage
        )
          .then((res) => {
            this.peiHistoryData = res.data.data;
            this.pagination = {
              ...this.pagination,
              totalItemCount: res.data.totalItemCount,
              pageCount: res.data.pageCount,
              currentPage: res.data.currentPage,
              count: res.data.count,
            };
          })
          .catch((err) => {
            this.response = err;
          });
      }
    },
    async onPageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      await this.getStudentPEI();
    },
    changeAcademicYear(event) {
      this.selectedAcademicYear =
        event.target.options[event.target.options.selectedIndex].value;
      this.getStudentPEI();
    },
    getAcademicYear() {
      this.$ApiGet('/api/academicyears/')
        .then((res) => {
          this.academicYearsList = res.data || [];
          this.academicYearsList.splice(0, 0, {
            id: 0,
            description: 'Año Académico',
            year: '0',
          });
        })
        .catch((err) => {
          this.response = err;
        });
    },
    setSelected(value) {
      this.selectedAcademicYear = value;
    },
    onSearch() {
      if (this.selectedAcademicYear) {
        this.pagination.currentPage = 1;
        this.getStudentPEI();
      }
    },
    downloadSheetRefferal(action) {
      let peiId = action.peiIdFormatted.replace('-', '');
      reportService.downloadMultipleReferralReports(peiId);
    },
    goToComments({ academicYearId, hasCommentFromParentPortal }) {
      let category = commentTypes.CrearModificarPEI;

      if (hasCommentFromParentPortal) {
        category = commentTypes.PEI;
      }

      this.$router.push({
        path: `/student/comments/commentshistory/${this.StudentId}/${category}/${academicYearId}`,
      });
    },
    closeShowErrorPanel(peiIdFormatted) {
      this.$ApiPost(`/api/pei/updatecommentreadflag/${peiIdFormatted}`);
    },
    async reloadRequiredSysParameters() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['RequireUsageGuaranteeCompletion'],
      });

      this.$store.commit(
        'setRequireUsageGuaranteeCompletionEnabled',
        data?.find((item) => item.name === 'RequireUsageGuaranteeCompletion')
          ?.staticValue
      );
    },
  },
  async mounted() {
    this.getStudentPEI();
    this.getAcademicYear();
    await this.reloadRequiredSysParameters();
  },
};
</script>
